import { products } from '../data/products'
import { categories, collections } from '../data/collections'
import type { Collection, Product } from '../types/product'

export function getProduct(slug: string): Product | undefined {
  return products.find((p) => p.slug === slug)
}

export function fromPrice(product: Product): number {
  return Math.min(...product.variants.map((v) => v.price))
}

export function hasRange(product: Product): boolean {
  return new Set(product.variants.map((v) => v.price)).size > 1
}

export function categoryTitle(id: string): string {
  return categories.find((c) => c.id === id)?.title ?? ''
}

export function resolveCollection(slug: string): Collection | undefined {
  const found = collections.find((c) => c.slug === slug)
  if (found) return found
  const cat = categories.find((c) => c.id === slug)
  if (!cat) return undefined
  return { slug: cat.id, title: cat.title, intro: `Alle producten in ${cat.title.toLowerCase()}.`, kind: 'category', value: cat.id }
}

export function productsForCollection(c: Collection): Product[] {
  const list = (() => {
    switch (c.kind) {
      case 'audience':
        return products.filter((p) => p.audiences.includes(c.value as Product['audiences'][number]))
      case 'badge':
        return products.filter((p) => p.badges.includes(c.value as Product['badges'][number]))
      case 'category':
        return products.filter((p) => p.category === c.value)
      default:
        return products
    }
  })()
  return [...list].sort((a, b) => b.reviews - a.reviews)
}

export function relatedProducts(product: Product, limit = 4): Product[] {
  const step = product.ritualStep
  const scored = products
    .filter((p) => p.slug !== product.slug && !product.includes?.includes(p.slug))
    .map((p) => {
      let score = p.reviews / 1000
      if (step && p.ritualStep && Math.abs(p.ritualStep - step) <= 2 && p.ritualStep !== step) score += 3
      if (p.category === product.category) score += 1
      if (p.slug === 'hammam-ritueel-set') score += 2
      return { p, score }
    })
    .sort((a, b) => b.score - a.score)
  return scored.slice(0, limit).map((s) => s.p)
}

export function searchProducts(query: string, limit = 6): Product[] {
  const q = query.trim().toLowerCase()
  if (!q) return []
  return products
    .filter((p) => `${p.name} ${p.subtitle} ${categoryTitle(p.category)}`.toLowerCase().includes(q))
    .slice(0, limit)
}
